import React, { useEffect } from 'react';
import Layout from 'Components/Layout';
import RouteLoading from 'Components/RouteLoading';
import useGetParameters from 'Hooks/query-hooks/parameters/useGetParameters';
import useGetVelocityConfigByRuleSetId from 'Hooks/query-hooks/parameters/useGetVelocityConfigByRuleSetId';
import errorController from 'Components/ErrorScreens';
import { useDispatch } from 'react-redux';
import { useParams, useLocation } from 'react-router-dom';
import EditVelocityForm from 'Components/EditVelocityForm';
import { addAdditionalBreadcrumbParams } from 'Store';
import useGetParameterById from 'Hooks/query-hooks/parameters/useGetParameterById';

const EditVelocity: React.FC<{}> = () => {
    const ruleSetId = sessionStorage.getItem('ruleSetId') || '';
    const { parameterId } = useParams<{ parameterId: string }>();
    const currentParameterAPI = useGetParameterById(parameterId);
    const parametersAPI = useGetParameters({
        queryParams: {
            status: JSON.stringify(['active']),
            source: JSON.stringify(['system'])
        }
    });
    const velocityConfigAPI = useGetVelocityConfigByRuleSetId(ruleSetId);
    const location = useLocation();
    const dispatch = useDispatch();

    useEffect(() => {
        if (currentParameterAPI.data && parameterId) {
            dispatch(
                addAdditionalBreadcrumbParams({
                    pathname: location.pathname,
                    params: {
                        parameterName: currentParameterAPI.data.message
                    }
                })
            );
        }
    }, [location, currentParameterAPI, dispatch, parameterId]);

    if (
        currentParameterAPI.isLoading ||
        currentParameterAPI.isFetching ||
        parametersAPI.isLoading ||
        parametersAPI.isFetching ||
        velocityConfigAPI.isLoading ||
        velocityConfigAPI.isFetching
    )
        return <RouteLoading />;
    if (parametersAPI.isError || velocityConfigAPI.isError || currentParameterAPI.isError) {
        const { errorCmp } = errorController([parametersAPI.error, velocityConfigAPI.error, currentParameterAPI.error]);
        return errorCmp;
    }

    const currentParameter = currentParameterAPI.data;

    // Reformat the time period object to display in the form
    let timePeriodKey = Object.keys(currentParameter.timePeriod!)[0];
    const timePeriodValue = currentParameter.timePeriod![timePeriodKey];

    // Capitalize first letter
    timePeriodKey = timePeriodKey.charAt(0).toUpperCase() + timePeriodKey.slice(1);

    // Remove 's' from the end if it exists
    if (!timePeriodKey.endsWith('s')) {
        timePeriodKey += 's';
    }
    const initialValues: ParameterVelocityFormSchema = {
        id: currentParameter.id,
        fieldName: currentParameter.fieldName,
        displayName: currentParameter.message,
        description: currentParameter.description,
        type: currentParameter.type,
        status: currentParameter.status,
        includeCurrentEvent: currentParameter.includeCurrentEvent ?? true,
        velocityType: currentParameter.velocityType ?? '',
        aggregationField:
            currentParameter.velocityType !== 'Non unique count' ? [currentParameter.aggregationField!] : [],
        timeField: velocityConfigAPI.data.timeField, // statically defined default values in FE
        timePeriod: {
            type: 'value',
            duration: timePeriodValue,
            unit: [timePeriodKey]
        },
        indexes: currentParameter.indexes ?? [],
        filters: currentParameter.filters ?? []
    };
    return (
        <Layout>
            <EditVelocityForm
                initialValues={initialValues}
                disableInputField={false}
                parameterData={parametersAPI.data}
                velocityConfigData={velocityConfigAPI.data}
            />
        </Layout>
    );
};

export default EditVelocity;
